module.exports = __webpack_public_path__ + "static/img/1.536661a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/附件八/1.jpg
// module id = pSF6
// module chunks = 1